// This file contains all functionality that are used in the product pages

import { helpers } from './helpers';
import { modals } from './modals';
import { icons } from './icons';

// tracking

export const product = {
    init: () => {
        console.debug("product.js: init");
        helpers.removePriceDecimals(".product-display-price, .regular-price, .discount-amount");
        product.toggleProductDescription();
        product.disablePriceZero();
        product.deskTriptych();
        //product.sendTrackingEvents();
        $("#product-description iframe, #product-description-new iframe").wrap("<div class='video-wrapper'></div>");
        /*const reviewsElement = document.getElementById('product-reviews');
        if (reviewsElement) {
            new ResizeObserver(product.toggleProductDescription).observe(reviewsElement);
        } else {
            console.error("product.js: init: reviewsElement (#product-reviews)not found");
        }*/

        product.toggleCoverImage = product.toggleCoverImage;
        product.playCoverVideo();
        product.extendedSelect();
        product.addEventListeners();
        product.ScrollProductThumbWrapper();
        product.columnScrolling.init();

        window.dispatchEvent(new Event("resize")); // gets the hello retail sliders to recalculate sizes after being revealed
    },
    addEventListeners: () => {
        window.addEventListener('CookiebotOnConsentReady', function (e) {
            product.sendTrackingEvents();
        }, false);

        prestashop.on('updateProduct', product.updateProduct);
        prestashop.on('updatedProduct', () => {
            //console.log("[product/init] updatedProduct event fired")
            product.extendedSelect();
            product.playCoverVideo();
        });
        prestashop.on('updateCart', () => {
            product.resetQuantityAfterUpdate();
        });

        $('#product .scroll-menu > div').on('click', product.scrollToSection);
        $("#product-description iframe").wrap("<div class='video-wrapper'></div>");
        $('#product .product-quantity-input .toggle').click(product.updateQuantity);
        $('#product #quantity_wanted').on("change", product.quantityOnChange);
        $("#product").on('mouseover', '.product-images > div', product.hoverImgThumb);
        //$("#product").on("click", ".product-description-short-expand", product.toggleShortDescription);
        $("#product").on('mouseover', '.product-video-thumb', () => {
            $("#product-cover-video").css("z-index", "1");
            $(".product-images > div").removeClass("selected-thumb");
            $(".product-video-thumb").addClass("selected-thumb");
        });
        $('.product-scroll-menu > div').on('click', (e) => {
            helpers.scrollWindow("." + $(e.currentTarget).data("section"), 200);
        });
        $('.product-details-mobile-expand .product-details-mobile-expand-touch-area').on("click", product.expandProductDetailsMobile);

        try {
            const cover = document.getElementsByClassName('product-cover');
            if (!cover || cover.length == 0) {
                //   console.log("[product.js/addEventListeners] -1- cover element not found");
                return;
            }
            helpers.swipe.addCallback(cover[0], {
                right: () => {
                    product.toggleCoverImage(false);
                },
                left: () => {
                    product.toggleCoverImage(true);
                }
            });
        }
        catch (error) {
            //console.log("[product.js/addEventListenerd] adding swipe callback", error);
        }

        $("body").on("click", ".product-image-arrow.next", () => {
            product.toggleCoverImage(true);
        });

        $("body").on("click", ".product-image-arrow.prev", () => {
            product.toggleCoverImage(false);
        });

        $("body").on("click", ".product-condition-classification", () => {
            product.recyleProductClassifications(false);
        });

        product.fixAddToCartButton();
    },
    scrollVideo: window.scrollVideo,
    sendTrackingEvents: () => {
        let countrySuffix = prestashop.urls.base_url == 'https://www.dpj.se/' ? 'SE' : prestashop.urls.base_url.slice(-3).replace("/", "").toUpperCase();
        let itemId = 'DPJ' + countrySuffix + $("#product-description-and-details").data("product-id");
        itemId = $("#product-description-and-details").data("attribute-id") == "0" ? itemId : itemId + "v" + $("#product-description-and-details").data("attribute-id");

        product.pushToDataLayer(itemId);

        //if (prestashop.urls.base_url != 'https://www.dpj.se/') {
        let conversionLabel = '';
        let userTypeVat = prestashop.configuration.display_prices_tax_incl ? 'private' : 'company';
        switch (prestashop.urls.base_url) {
            case 'https://www.dpj-workspace.com/at/':
                conversionLabel = "zHPeCIDDpqkYEOTLmbcB";
                break;
            case 'https://www.dpj-workspace.com/de/':
                conversionLabel = "wJIJCNz6l6kYELfRp-UB";
                break;
            case 'https://www.dpj-workspace.com/dk/':
                conversionLabel = "_YoBCP3V8qMYEOzgsoEC";
                break;
            case 'https://www.dpj-workspace.com/fi/':
                conversionLabel = "T0XcCMCwoakYEKvWl8QB";
                break;
            case 'https://www.dpj-workspace.com/fr/':
                conversionLabel = "VcreCJG1uKYYELKmgroo";
                break;
            case 'https://www.dpj-workspace.com/nl/':
                conversionLabel = "2BcoCPOa0JMYELmc4MUo";
                break;
            case 'https://www.dpj-workspace.com/be/':
                conversionLabel = "mSe0CK_j05wcEJuporND";
                break;
            case 'https://www.dpj.se/':
                conversionLabel = "mGUpCO--n6kYEJ-2qN0D";
        }
        try {
            gtag('event', 'page_view', {
                'send_to': window.adsId,
                'value': $("#price-data").data("price-value"),
                'user_type_vat': userTypeVat,
                'items': [{
                    'id': itemId,
                    'google_business_vertical': 'retail'
                }]
            });
            gtag('event', 'conversion', {
                'send_to': `${window.adsId}/${conversionLabel}`,
                'user_type_vat': userTypeVat,
            });
        }
        catch (error) {
            console.error("product.js: error sending tracking events", error);
        }
        /*console.log({
            'send_to': window.adsId,
            'value': $("#price-data").data("price-value"),
            'items': [{
                'id': itemId,
                'google_business_vertical': 'retail'
            }]
        }, { 'send_to': `${window.adsId}/${conversionLabel}` });*/
        //}


        /*if (prestashop.urls.base_url == 'https://www.dpj-workspace.com/de/') {
            gtag('event', 'page_view', {
                'send_to': 'AW-480897207',
                'value': $("#price-data").data("price-value"),
                'items': [{
                    'id': itemId,
                    'google_business_vertical': 'retail'
                }]
            });
            gtag('event', 'conversion', {'send_to': 'AW-480897207/wJIJCNz6l6kYELfRp-UB'});
        }
        else {
            product.pushToDataLayer(itemId);
        }*/
    },
    pushToDataLayer: (itemId) => {
        let data = {
            event: "view_item",
            ecommerce: {
                currency: prestashop.currency.iso_code,
                value: $("#price-data").data("price-value"),
                items: [{
                    item_id: itemId,
                    item_name: $(".breadcrumb-item.active span[itemprop='name']").text(),
                    discount: $("#price-data").data("re-value"),
                    item_brand: $(".product-manufacturer-header a").text(),
                    price: $("#price-data").data("price-value"),
                    item_variant: $("#product-variant-data").text().trim().slice(0, -2),
                    /*item_list_id: "related_products",
                    item_list_name: "Related Products",*/
                }]
            }
        }
        //data.ecommerce.items[0].item_id = $(".product-details").prop("data-attribute-id") == "0" ? $(".product-details").attr("data-product-id") : $(".product-details").attr("data-product-id") + "-" + $(".product-details").prop("data-attribute-id");
        /*let countrySuffix = prestashop.urls.base_url == 'https://www.dpj.se/' ? 'SE' : prestashop.urls.base_url.slice(-3).replace("/", "").toUpperCase();
        let itemId = 'DPJ' + countrySuffix + $(".product-details").data("product-id");
        data.ecommerce.items[0].item_id = $(".product-details").data("attribute-id") == "0" ? itemId : itemId + "v" + $(".product-details").data("attribute-id");*/
        $(".breadcrumb-item:not('.active')").each((i, el) => {
            if ($("body").hasClass("product-id-category-464") && i > 0) {
                var catIndex = i == 1 ? "" : i;
                data.ecommerce.items[0]["item_category" + catIndex] = $(el).find("span[itemprop='name'").text();
            }
            else if (!$("body").hasClass("product-id-category-464") && i > 1) {
                var catIndex = i == 2 ? "" : i - 1;
                data.ecommerce.items[0]["item_category" + catIndex] = $(el).find("span[itemprop='name'").text();
            }
        });
        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
    },
    // @johan-st
    // NOTE: (notable) assumptions:
    // - '.copyright' to be the last element in footer and
    // - '#content-wrapper>.row' to exist and encompas the are where the button should be visible and
    // - both to have their padding set to 0
    // Known issues:
    // - If the screen is resized from large to small or small to large, the button will not be fixed or unfixed until the observer is triggered. A solution could be to listen on resize and run som checks to see if the button should be fixed or not. I will not implement this at this time as it is likely to be an rare occurance and the times this will pose an issue should be exceedingly rare.
    fixAddToCartButton: () => {
        // setup variable. We only need to do this once unless screen height changes
        const el = $(".product-add-to-cart");
        const elDisplacedHeight = el.outerHeight(true);

        const elSiblingPrev = el.prev();
        const elFooter = $(".copyright");

        function toFixed() {
            el.hide();
            elSiblingPrev.css("padding-bottom", elDisplacedHeight + "px");
            elFooter.css("padding-bottom", elDisplacedHeight + "px");
            el.addClass("fixed");
            el.fadeIn();
            if ($("#fc_frame").length) { // Moves freshchat widget button so it's not overlaying the fixed add to cart button
                $("#fc_frame").css("bottom", "96px");
            }
        };
        function toStatic() {
            elSiblingPrev.css("padding-bottom", "0px");
            elFooter.css("padding-bottom", "0px");
            el.removeClass("fixed");
            if ($("#fc_frame").length) { // Moves freshchat widget button to it's original position
                $("#fc_frame").css("bottom", "15px");
            } 
        };

        const observer = new IntersectionObserver((entries) => {
            if (!helpers.isSmallDevice()) {
                toStatic();
                return;
            }
            if (entries.length < 1) {
                toStatic();
                console.error("No entries in observer, setting add-to-cart button to static");
                return;
            }
            if (entries[0].isIntersecting) {
                toStatic();
            } else {
                toFixed();
            }

        }, { threshold: 0.0 });

        try {
            observer.observe(document.querySelector("#content-wrapper>.row"));
        } catch (error) {
            console.error("error in fixAddToCartButton", error);
        }
    },
    disablePriceZero: () => {
        const price = $(".product-display-price").attr("content");
        if (price == "0") {
            $(".add-to-cart").addClass("disabled");
            $(".add-to-cart").prop("disabled", true);
            $(".product-prices").hide();
        }
        else {
            $(".product-prices").show();
        }
    },
    /*toggleShortDescription: () => {
        $("#product-description-short").toggleClass("expanded");
        if ($("#product-description-short").hasClass("expanded")) {
            $(".product-description-short-expand > span:nth-of-type(1)").hide();
            $(".product-description-short-expand > span:nth-of-type(2)").show();
        }
        else {
            $(".product-description-short-expand > span:nth-of-type(1)").show();
            $(".product-description-short-expand > span:nth-of-type(2)").hide();
        }
    },*/
    getInstructionVideo: () => {
        if (helpers.getParameterByName("instructions")) {
            const video = $("#product-description iframe").last();
            if (video.length) {
                if ($("#instruction-video-modal").length) {
                    $("#instruction-video-modal").show();
                }
                else {
                    modals.ol.append(`
                        <div class="modal-box" id="instruction-video-modal">
                            <i class="fas fa-times-circle close-modal"></i>
                        </div>
                    `);
                    $("#instruction-video-modal").show();
                    video.clone().appendTo("#instruction-video-modal");
                }
                modals.togglePageOverlay();
            }
        }
    },
    columnScrolling: {
        currentColPosition: 0,
        productInfoSelector: "#product #content-wrapper > div.row:nth-of-type(1) > .col-lg-5 > div:nth-of-type(1)",
        init: () => {
            if (!helpers.isSmallDevice()) { // re-init this on window size change?
                let productInfoMaxHeight = 790 - $(".product-actions").outerHeight(true);
                let windowWidth = helpers.getWindowWidth();
                if (windowWidth < 1440) { // 1440 is our highest breakpoint
                    const rightColHeight = ($(".product-images-container").height() + 52) < 608 ? 608 : $(".product-images-container").height() + 52; // 52px to account for the payment methods section that sticks out below line
                    $("#product #content-wrapper > div.row:nth-of-type(1) > .col-lg-5").height(rightColHeight); // this is done to make right column on product page as long as the left column
                    productInfoMaxHeight = rightColHeight - 52 - $(".product-actions").outerHeight(true);
                }
                $(product.columnScrolling.productInfoSelector).css("max-height", productInfoMaxHeight + "px");
                window.addEventListener('wheel', product.columnScrolling.handleScrolling, {passive: false});
                document.querySelector(product.columnScrolling.productInfoSelector).addEventListener('wheel', product.columnScrolling.handleScrolling, {passive: false});
            }
        },
        handleScrolling: (e) => {
            if (window.pageYOffset == 0) {
                let deltaY = e.deltaY;
                const rightCol = $(product.columnScrolling.productInfoSelector)[0];
                let isColScrollableDown = Math.abs(rightCol.scrollHeight - rightCol.scrollTop - rightCol.clientHeight) > 1;
                if ((isColScrollableDown && deltaY) || (rightCol.scrollTop && deltaY < 0)) { // scroll right col
                    e.preventDefault();
                    e.stopPropagation();
                    product.columnScrolling.currentColPosition = rightCol.scrollTop + deltaY;
                    rightCol.scrollTo({
                        top: product.columnScrolling.currentColPosition,
                        behavior: "smooth"
                    });
                }
            } 
        },
    },
    recyleProductClassifications: () => {
        if ($("#recycleLabelClassificationsModal").length) {
            $("#recycleLabelClassificationsModal").show();
        }
        else {
            modals.ol.append(`
                <div class="modal-box" id="recycleLabelClassificationsModal">
                    <p class="text-right">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg close-modal" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    </p>
                    <h2>Så här  klassificerar vi våra möbler för återbruk</h2>
                    <p><b>Nyskick</b> – produkten är hel och har inte använts men förpackningen är skadad.</p>
                    <p><b>Mycket gott skick</b> – produkten är i mycket gott skick med smärre tecken på användning (ex. märken efter tidigare montering).</p>
                    <p><b>Ofullständig produkt</b> – produkten är i gott skick/nyskick men saknar någon del/ ingår i ofullständigt flerpack.</p>
                    <p><b>Gott skick</b> – produkten är fullt brukbar men har synliga skador (ex. repor).</p>
                    <p><b>Fabrikationsfel</b> – produkten uppvisar fabrikationsfel (ex. blekt eller ojämn färg, ojämnheter i materialet) men är fullt brukbar.</p>
                    <p><b>Demo från butik</b> – produkten är i fint skick och har visats upp för/har testats av kunder i vår butik.</p>
                </div>
            `);
            $("#recycleLabelClassificationsModal").show();
        }
        modals.togglePageOverlay();
    },
    toggleProductDescription: () => {
        if ($(".product-description-block-wrap").length) {
            let maxHeight = 550;
            if (
                helpers.isSmallDevice() && $("#product-description-new").height() < maxHeight ||
                !helpers.isSmallDevice() && $("#product-description-new").height() < maxHeight && $(".product-details-desktop").height() < maxHeight
            ) {
                $(".product-description-block-wrap .product-description-fade").addClass("hidden");
                $(".product-description-block-wrap").css("height", "auto");
            }

            $("#product").on("click", ".product-description-fade .input-button", () => {
                $(".product-description-block-wrap .product-description-fade").addClass("hidden");
                $(".product-description-block-wrap").css("height", "auto");
            });
        }
    },
    playCoverVideo: () => { // This function is used to play the video on the product page.
        let hasVideo = $("#product-cover-video").length > 0;
        let showVideo = !window.location.hash.startsWith("#/");
        if (hasVideo) {
            helpers.tryCatchCapture(() => {
                document.getElementById("product-cover-video").play();
            }, ["product.js", "playCoverVideo()"]);
        }
        if (hasVideo && !showVideo) {
            product.toggleCoverImage(true);
        }
    },
    updateProduct: (e) => { // updateProduct is called when the product page is about to update.
        console.debug("product.js: updateProduct");
        modals.renderLoading();
        const attrID = e.id_product_attribute;
        const prodID = $("#product_page_product_id").val();
        const token = prestashop.static_token;
        let url = `${prestashop.urls.base_url}index.php?controller=product&token=${token}&id_product=${prodID}&id_customization=0&qty=1`;

        const currentUrlParameters = new URLSearchParams(window.location.search);
        if (currentUrlParameters.get("preview") === "1") {
            ["preview", "id_employee", "adtoken", "product_preview_token"].forEach((parameter) => {
                const value = currentUrlParameters.get(parameter);
                if (value !== null) {
                    url += `&${encodeURIComponent(parameter)}=${encodeURIComponent(value)}`;
                }
            });
        }

        $(`.product-variants select`).each((i, el) => {
            const input = $(el);
            let attr = input.data("product-attribute");
            url += encodeURI(`&group[${attr}]=${input.val()}`);
        });
        const data = {
            id_product_attribute: attrID
        };

        const thumbCount = $(".product-thumbs-wrapper .product-images > div").length;
        let thumbIndex = false;
        if ($(".product-thumbs-wrapper .product-images .selected-thumb").length) {
            thumbIndex = $(".product-thumbs-wrapper .product-images .selected-thumb").index();
        }

        $.post(url, data)
            .then((resp) => {
                const preview = $(resp);
                const selectors = [
                    `.product-images-container`,
                    `.product-prices`,
                    `#product-availability`,
                    `.input-button.add-to-cart`,
                    `#product-description-and-details`,
                    `.product-order-info .lowest-price`
                ];
                let foundSelectors = 0;
                let completedSelectors = 0;
                console.debug("preview", preview);
                $.each(selectors, (i, el) => {
                    console.debug("each i", i);
                    if ($(el).length === 0) {
                        console.error("product.js: updateProduct: Selector not found in DOM:", el);
                        return;
                    }
                    foundSelectors++;
                    $(el).fadeTo(200, 0, () => {
                        console.debug("product.js: updateProduct: fade each el", el);
                        $(el).replaceWith(preview.find(el));
                        completedSelectors++;
                        if (completedSelectors === foundSelectors) {
                            console.debug("product.js: updateProduct: All animations completed");
                            product.sendTrackingEvents();
                            helpers.removePriceDecimals(".product-display-price, .regular-price, .discount-amount, .lowest-price span");
                            product.disablePriceZero();
                            icons.init();
                            $('.product-details-mobile-expand .product-details-mobile-expand-touch-area').on("click", product.expandProductDetailsMobile);
                            helpers.tryCatchCapture(() => {
                                const cover = document.querySelector('.product-cover');
                                if (!cover) {
                                    return;
                                }
                                helpers.swipe.addCallback(cover, {
                                    right: () => { product.toggleCoverImage(false) },
                                    left: () => { product.toggleCoverImage(true) }
                                });

                                if ($(".product-thumbs-wrapper .product-images > div").length == thumbCount && thumbIndex !== false) {
                                    const selectedEl = $(".product-thumbs-wrapper .product-images > div").eq(thumbIndex);
                                    $(".product-images > div, .product-video-thumb").removeClass("selected-thumb");
                                    selectedEl.addClass("selected-thumb");
                                    const selectedImg = selectedEl.find("img");
                                    const newSrc = selectedImg.data("lightbox-src") ? selectedImg.data("lightbox-src") : selectedImg.attr("src");
                                    $(".product-cover > img").attr("src", newSrc);
                                    $("#product-cover-video").css("z-index", "-1");
                                }
                                else {
                                    product.playCoverVideo();
                                }
                            }, ["product.js", "updateProduct()"]);
                        }
                    })
                })

                modals.togglePageOverlay();
            }).fail((resp) => {
                console.error("product update fail", resp);
                modals.togglePageOverlay();
            });
    },
    updateQuantity: (e) => {
        if (e.currentTarget.classList.contains("disabled")) {
            console.debug("updateQuantity() called on disabled button, returning");
            return;
        }
        const btn = $(e.currentTarget);
        const wrapper = btn.parent();
        const input = wrapper.find(".input-number");
        const min = parseInt(input.prop("min")) > 0
            ? parseInt(input.prop("min"))
            : 1;
        let val = parseInt(input.val())
            ? parseInt(input.val())
            : min;
        if (btn.hasClass("plus")) {
            val += min;
        }
        else if (btn.hasClass("minus")) {
            val -= min;
        }
        val = val < min ? min : val;
        val -= val % min;
        if (val === min) {
            wrapper.find(".minus").addClass("disabled");
        }
        else {
            wrapper.find(".minus").removeClass("disabled");
        }
        input.val(val);
        // console.log(`updateQuantity.min = ${min} \nupdateQuantity.val = ${val}`);
    },
    quantityOnChange: (e) => {
        const input = $(e.currentTarget);
        const min = parseInt(input.prop("min")) > 0
            ? parseInt(input.prop("min"))
            : 1;
        let val = parseInt(input.val())
            ? parseInt(input.val())
            : min;
        val = val < min ? min : val;
        val -= val % min;
        input.val(val);
        // console.log(`quantityOnChange.min = ${min} \nquantityOnChange.val = ${val}`);
    },
    hoverImgThumb: (e) => {
        const img = $(e.currentTarget).find("img");
        const newSrc = img.data("lightbox-src") ? img.data("lightbox-src") : img.attr("src");
        $(".product-cover > img").attr("src", newSrc);
        $("#product-cover-video").css("z-index", "-1");
        $(".product-images > div, .product-video-thumb").removeClass("selected-thumb");
        $(e.currentTarget).addClass("selected-thumb");
        /*const cover = $(".product-cover img");
        const orgSrc = cover.data("src");
        if (orgSrc == cover.attr("src")) {
            const img = $(e.currentTarget).find("img");
            const newSrc = img.data("lightbox-src") ? img.data("lightbox-src") : img.attr("src");
            cover.attr("src", newSrc);
        }*/
        /*else {
            cover.attr("src", orgSrc);
        }*/
    },

    /**
     * This function is used to move show the next or previous image in the product gallery.
     * @param {boolean} next - If true, the next image will be shown. If false, the previous image will be shown.
     *
     * NOTE! this is a slot for the function called. This allowes us to switch out the function called without changing the listeners etc.
     */
    toggleCoverImage: (next) => {
        console.error("toggleCoverImage() must be set to the desired function before calling it.");
        // helpers.alertEmail({
        //     subject: "toggleCoverImage() was called before set",
        //     context: "product.js",
        //     msg: "toggleCoverImage() must be set to the desired function before calling it."
        // });
    },

    /**
     * This function is used to toggle the product image when the user clicks on the arrows
     *
     * @param {boolean} next - If true, the next image will be shown. If false, the previous image will be shown.
     */
    toggleCoverImage: (next) => {
        const video = $("#product-cover-video");
        const cover = $(".product-cover > img");
        const thumbs = $(".product-images img");
        const thumbLen = thumbs.length;
        $(".product-images > div, .product-video-thumb").removeClass("selected-thumb");
        if (video.length && video.css("display") == "block" && video.css("z-index") == "1") {
            video.css("z-index", "-1");
            $(".product-images > div").eq(0).addClass("selected-thumb");
            return false;
        }
        if ((thumbLen + video.length) > 1) {
            thumbs.each((index, el) => {
                let loopImg = $(el);
                let loopImgSrc = loopImg.data("lightbox-src") ? loopImg.data("lightbox-src") : loopImg.attr("src");
                if (loopImgSrc == cover.attr("src")) {
                    let currentIndex = index;
                    let newIndex = next ? (currentIndex + 1) : (currentIndex - 1);
                    if (newIndex >= thumbLen) {
                        newIndex = 0;
                        if (video.length) {
                            video.css("z-index", "1");
                            video[0].play();
                            $(".product-video-thumb").addClass("selected-thumb");
                        }
                        else {
                            $(".product-images > div").eq(newIndex).addClass("selected-thumb");
                        }
                    }
                    else if (newIndex < 0) {
                        newIndex = (thumbLen - 1);
                        if (video.length) {
                            video.css("z-index", "1");
                            video[0].play();
                            $(".product-video-thumb").addClass("selected-thumb");
                        }
                        else {
                            $(".product-images > div").eq(newIndex).addClass("selected-thumb");
                        }
                    }
                    else if (newIndex == 1 && helpers.isSmallDevice()) {
                        if (video.length) {
                            video[0].pause();
                            video[0].currentTime = 0;
                            video[0].load();
                            video[0].play();
                            video.css("z-index", "1");
                            $(".product-video-thumb").addClass("selected-thumb");
                        }
                        else {
                            $(".product-images > div").eq(newIndex).addClass("selected-thumb");
                        }
                    }
                    else {
                        video.css("z-index", "-1");
                        $(".product-images > div").eq(newIndex).addClass("selected-thumb");
                    }
                    let newImg = $(".product-images > div").eq(newIndex).find("img");
                    let newImgSrc = newImg.data("lightbox-src") ? newImg.data("lightbox-src") : newImg.attr("src");
                    cover.attr("src", newImgSrc);
                    return false;
                }
            });
        }
    },

    extendedSelect: () => {
        // console.debug("[extendedSelect] called")
        const cssClass = {
            select: "custom-select__select-div",
            selectClosed: "custom-select__select-div--closed",
            selectHidden: "custom-select__select-div--hidden",
            optionContainer: 'custom-select__options-container',
            option: "custom-select__option-div",
            optionHidden: "custom-select__option-div--hidden",
            optionDisabled: "custom-select__option-div--disabled",
            optionSelected: "custom-select__option-div--selected",
            optionAvailable: "custom-select__option-div--available",
            optionOrder: "custom-select__option-div--order",
            optionOutOfStock: "custom-select__option-div--out-of-stock",
            svg: "custom-select__svg",
            varsInStock: "product-variants__variants-in-stock",
            varsInStockHidden: "product-variants__variants-in-stock--hidden",
            numVarsInStock: "product-variants__variants-in-stock-number"
        }

        //  const dpj_combinations={$dpj_combinations|@json_encode nofilter};
        //  This is set in catgalog/_partials/product-vatiants.tpl
        const setSelectFallback = (min = 15) => {
            console.log(`falling back to standard selects for ${min} minutes. Unset by calling 'setSelectFallback(0)'.`)
            const expireAt = Date.now() + (min * 60000)
            window.localStorage.setItem("extendesSelect-useFallback", expireAt)
        }
        // facilitate test
        window.setSelectFallback = setSelectFallback

        const useFallback = window.localStorage.getItem("extendesSelect-useFallback") < Date.now() ? false : true;
        const revertToFallback = () => {
            setSelectFallback()
            try {
                $(`.${cssClass.select}`).each((i, selectDiv) => {
                    selectDiv.classList.add(cssClass.selectHidden)
                    const selectId = selectDiv.id.split("div-")[1]
                    document.querySelectorAll(`#${selectId}`).forEach((select, i) => {
                        select.style["display"] = "flex"
                    });
                })
            } catch (error) {
                console.log("revertToFallback() failed:", error);
                helpers.alertEmail({
                    subject: "catch in product.js",
                    context: "extended select",
                    msg: "revertToFallback() failed"
                }, error)
            }
        }
        const selectedOptionClicked = ev => {
            try {
                // console.debug("[extendedSelect] selectOptionClicked")
                ev.stopPropagation()
                const selectDiv = ev.target.parentNode.classList.contains(cssClass.select) ? ev.target.parentNode : ev.target.parentNode.parentNode;
                const wasClosed = selectDiv.classList.contains(cssClass.selectClosed)
                closeAllSelects()
                selectDiv.classList.toggle(cssClass.selectClosed, !wasClosed)
            } catch (error) {
                console.log("an error occured", error);
                revertToFallback()
                helpers.alertEmail({
                    subject: "catch in product.js",
                    context: "extended select",
                    msg: "selectedOptionClicked() failed"
                }, error)
            }
        }

        const newOptionClicked = ev => {
            // console.debug("[extendedSelect] newOptionClicked")
            try {
                ev.stopPropagation()
                const optionDiv = ev.target.classList.contains(cssClass.option) ? ev.target : ev.target.parentNode;
                const clickedValue = optionDiv.getAttribute("data-id_attribute")
                const selectDiv = optionDiv.parentNode.parentNode
                selectDiv.classList.add(cssClass.selectClosed)
                const selectId = selectDiv.id.split("div-")[1]
                document.querySelectorAll(`#${selectId}`).forEach((select, i) => {
                    select.value = clickedValue
                    select.dispatchEvent(new Event("change", { bubbles: true, cancelable: true }))
                });
            } catch (error) {
                console.log("an error occured", error);
                revertToFallback()
                helpers.alertEmail({
                    subject: "catch in product.js",
                    context: "extended select",
                    msg: "newOptionClicked() failed",
                }, error)
            }
        }
        const disabledOptionClicked = ev => {
            // console.debug("[extendedSelect] disabledOptionClicked")
            try {
                ev.stopPropagation()
            } catch (error) {
                console.log("an error occured", error);
                revertToFallback()
                helpers.alertEmail({
                    subject: "catch in product.js",
                    context: "extended select",
                    msg: "disabledOptionClicked() failed",
                }, error)
            }
        }
        const closeAllSelects = ev => {
            // console.debug("[extendedSelect] closeAllSelects")
            $(`.${cssClass.select}`).each((i, selectDiv) => {
                selectDiv.classList.add(cssClass.selectClosed)
            })
        }
        const getSelectedList = () => {
            // console.debug("[extendedSelect] getSelectedList")
            let res = { list: "", key: "", array: [] }
            const elemVariants = document.querySelector(".product-variants")
            const els = elemVariants.getElementsByClassName(cssClass.optionSelected)
            for (let i = 0; i < els.length; i++) {
                const el = els[i];
                res.array.push({ group: el.getAttribute("data-id_attribute_group"), attr: el.getAttribute("data-id_attribute") })
            }
            res.list = listFromArray(res.array)
            res.key = keyFromArray(res.array)
            return res
        }
        const listFromArray = arr => {
            // console.debug("[extendedSelect] listFromArray")
            const quoteId = el => `'${el.attr}'`
            return arr.map(quoteId).join(",")
        }
        const keyFromArray = arr => {
            // A sorted key makes matching independent of attribute-group order.
            const attributeIds = arr.map(el => Number.parseInt(el.attr, 10))
            return attributeIds.sort((a, b) => a - b).join("-")
        }
        const getOptionList = (selectedList, optionDiv) => {
            // console.debug("[extendedSelect] getOptionList")
            const res = { array: [], list: "", key: "" }
            const opt = {
                group: optionDiv.getAttribute("data-id_attribute_group"),
                attr: optionDiv.getAttribute("data-id_attribute")
            }
            for (let i = 0; i < selectedList.array.length; i++) {
                const el = selectedList.array[i];
                if (el.group === opt.group) {
                    res.array[i] = { group: el.group, attr: opt.attr }
                } else {
                    res.array[i] = { group: el.group, attr: el.attr }
                }
            }
            res.list = listFromArray(res.array)
            res.key = keyFromArray(res.array)
            /** /
            console.debug("getOptionList for",
                "\nselectedList", selectedList,
                "\noptionDiv", optionDiv,
                "\nres", res);
            /**/
            return res
        }

        const getAvailabilityClass = (combination, oosp) => {
            // console.debug("[extendedSelect] getAvailabilityClass")
            if (combination.stockState === "available") {
                return cssClass.optionAvailable
            } else if (combination.stockState === "order") {
                return cssClass.optionOrder
            } else if (combination.stockState === "unavailable") {
                return cssClass.optionOutOfStock
            }

            // Compatibility with cached or older payloads that only have isInStock.
            if (combination.isInStock) {
                return cssClass.optionAvailable
            } else if (oosp == 0) {
                return cssClass.optionOutOfStock
            } else {
                return cssClass.optionOrder
            }
        }

        if (!useFallback) {
            // console.debug("[extendedSelect] stage 1")
            if (!document.querySelector(".product-variants")) {
                console.log("[extendedSelct] no product variants found, exiting")
                return;
            }
            try {
                const optionDivs = $(`.${cssClass.option} `)
                const selectedList = getSelectedList()

                // variants in stock
                // let numVarsInStock = 0
                // for (const comboId in dpj_combinations) {
                //     if (dpj_combinations[comboId].quantity > 0) { numVarsInStock++ }
                // }
                // try {
                //     console.log(dpj_combinations);
                //     if (numVarsInStock >= 1) {
                //         document.querySelector(`.${cssClass.numVarsInStock}`).innerText = numVarsInStock
                //         document.querySelector(`.${cssClass.varsInStock}`).classList.remove(cssClass.varsInStockHidden)
                //     }
                // } catch (error) {
                //     console.log("failed to set 'num variants in stock'", error);
                // }
                // end

                optionDivs.each((i, div) => {
                    // console.debug("[extendedSelect] optionDivs.each")
                    const divCombo = getOptionList(selectedList, div)
                    let avaiabilityClassFound = false
                    for (const comboId in dpj_combinations) {
                        const combination = dpj_combinations[comboId]
                        const combinationMatches = combination.key
                            ? combination.key === divCombo.key
                            : combination.list === divCombo.list
                        if (combinationMatches) {
                            avaiabilityClassFound = true
                            const cssAvailablilityClass = getAvailabilityClass(combination, div.getAttribute("data-oosp"))
                            div.classList.add(cssAvailablilityClass)
                            break
                        }
                    }
                    if (!avaiabilityClassFound) {
                        // console.debug("[extendedSelect] optionDivs.each - avaiabilityClassFound=false")
                        div.classList.toggle(cssClass.optionDisabled, true)
                        div.classList.toggle(cssClass.optionHidden, true)

                    }
                })
            } catch (error) {
                console.log("extendedSelect() stage 1 failed:", error);
                revertToFallback()
                helpers.alertEmail({
                    subject: "catch in product.js",
                    context: "extended select",
                    msg: "extendedSelect() stage 1 failed",
                }, error)
            }

            try {
                // console.debug("[extendedSelect] stage 2")
                // console.debug("[extendedSelect] add event listeners")
                // add event listeners
                $(`.${cssClass.option
                    } `).each((i, optionDiv) => {
                        if (optionDiv.getAttribute("data-selected")) {
                            optionDiv.addEventListener("click", selectedOptionClicked)
                        } else if (optionDiv.classList.contains(cssClass.optionDisabled)) {
                            optionDiv.addEventListener("click", disabledOptionClicked)
                        } else {
                            optionDiv.addEventListener("click", newOptionClicked)
                        }
                    })
                document.addEventListener("click", closeAllSelects)
                // unhide extended selects
                // console.debug("[extendedSelect] unhide extended selects, hide standard selects")
                $(`.${cssClass.select
                    }`).each((i, selectDiv) => {
                        selectDiv.classList.remove(cssClass.selectHidden)
                        const selectId = selectDiv.id.split("div-")[1]
                        document.querySelectorAll(`#${selectId}`).forEach((select, i) => {
                            select.style["display"] = "none"
                        });
                    })
            } catch (error) {
                console.log("extendedSelect() stage 2 failed:", error);
                revertToFallback()
                helpers.alertEmail({
                    subject: "catch in product.js",
                    context: "extended select",
                    msg: "extendedSelect() stage 2 failed",
                }, error)
            }
        }
        // console.debug("[extendedSelect] <-end->")
    },
    deskTriptych: () => {
        if (document.getElementById("panel_1")) {
            const p1 = document.getElementById("panel_1")
            const pt1 = document.getElementById("panel_heading_1")
            const p2 = document.getElementById("panel_2")
            const pt2 = document.getElementById("panel_heading_2")
            const p3 = document.getElementById("panel_3")
            const pt3 = document.getElementById("panel_heading_3")
            pt1.onclick = (ev) => {
                p1.classList.toggle("panel--closed")
            }
            pt2.onclick = (ev) => {
                p2.classList.toggle("panel--closed")
            }
            pt3.onclick = (ev) => {
                p3.classList.toggle("panel--closed")
            }
        }
    },
    ScrollProductThumbWrapper: () => {
        // This is only used if there is more than 6 product images (or 5 + video)
        // The function allows user to scroll the thumbnail view
        if ($(".thumbs-navigate-down").length) {

            $("body").on("click", ".thumbs-navigate-down", () => {
                $('.product-thumbs-wrapper').animate({ scrollLeft: '+=100px' }, 400);
            });

            $("body").on("click", ".thumbs-navigate-up", () => {
                $('.product-thumbs-wrapper').animate({ scrollLeft: '-=100px' }, 400);
            });

            // Display or hide scroll-buttons depending on what direction the user can scroll (not down if the user reached bottom for example)
            $('.product-thumbs-wrapper').on('scroll', function() {
                if ($(".product-thumbs-wrapper")[0].offsetWidth + $(".product-thumbs-wrapper")[0].scrollLeft == $(".product-thumbs-wrapper")[0].scrollWidth) {
                    $(".thumbs-navigate-down").css("display", "none");
                }
                else {
                    $(".thumbs-navigate-down").css("display", "block");
                }

                if ($(".product-thumbs-wrapper").scrollLeft() == 0) {
                    $(".thumbs-navigate-up").css("display", "none");
                } 
                else {
                    $(".thumbs-navigate-up").css("display", "block");
                }
            });

        }

    },
    resetQuantityAfterUpdate: () => {
        var quantityVal = 1;
        if (typeof $("#quantity_wanted").attr("min") !== "undefined") {
            quantityVal = $("#quantity_wanted").attr("min");
        }
        $("#quantity_wanted").val(quantityVal);
    },
    expandProductDetailsMobile: (event) => {
        if ($(".product-additional-details-block-mobile").length) {
            var expandingBlock = $(event.currentTarget).parent().find(".product-details-mobile-expanding-area");
            if (expandingBlock.css("display") == "block") {
                expandingBlock.slideUp();
                $(event.currentTarget).removeClass("product-details-mobile-expand-touch-area-open");
            } else {
                expandingBlock.slideDown();
                $(event.currentTarget).addClass("product-details-mobile-expand-touch-area-open");
            }
        }
    },

    /*renderPriceMatcher: () => {
        if ($("#price-matcher").length) {
            $("#price-matcher").show();
            modals.togglePageOverlay();
        }
        else {
            modals.ol.append(`
                <div class="modal-box" id="price-matcher">
                <i class="fas fa-times-circle close-modal"></i>
                </div>
                `);
                $.get(prestashop.urls.base_url + 'content/71-price-matcher', function(data, status) {
                    if (status == 'success' && $(data).find("#price-matcher-content").length) {
                        $("#price-matcher").append($(data).find("#price-matcher-content").html());
                        $("#price-matcher").show();
                    modals.togglePageOverlay();
                }
            });
        }
    },*/
}
